import { CategorizedTags, TagModel } from '../models';

export default abstract class TagRepository {
  abstract getTags(): Promise<CategorizedTags>;
  abstract createTag(name: string, token: string): Promise<TagModel>;
}
